export const signIn = {
  SignInAccount: "Sign in to your account",
  ForgotPassword: "Forgot password?",
  StaySignedIn: "Stay signed in",
  SignIn: "Sign in",
  ContinueToFullscript: "Continue to Fullscript",
  NewToFullScript: "New to Fullscript?",
  CreateAccount: "Create an account",
  EnterValidEmail: "Please enter a valid email",
  CaptchaFailed:
    "For security purposes we need to verify your account. Please check your email for an easy sign in link.",
  PasswordIsRequired: "Password is required",
  IncorrectEmailOrPassword: "Incorrect email or password. Please try again.",
  ResetPassword: "Reset your password",
  NotAuthorized: "You are not authorized to sign in with this email",
  ContactAPrac: "Please contact your practitioner",
  HappensToTheBest:
    "It happens to the best of us. We'll send you an email with instructions to reset your password.",
  EmailMeLink: "Email me a reset link",
  ReturnToSignIn: "Return to Sign In",
  SetYourPassword: "Set your new password",
  ItMustBeLong: "It must be at least 8 characters long.",
  PlaceholderPassword: "New password",
  PlaceHolderConfirmPassword: "Confirm new password",
  EmailHasBeenSent: "An email has been sent to {{ email }}.",
  IfEmailExists:
    "If the account <1>{{ email }}</1> exists, you will receive an email with instructions on how to set a new password.",
  DidNotGetEmail: "Didn't get the email? Check your spam folder or <1>resend</1>.",
  EmailSentAgain: "Email succesfully sent again!",
  PasswordsDontMatch: "The passwords you entered do not match.",
  LinkIsBroken: "Hmm, that link appears to be broken.",
  TryAgainResetPassword: "To reset your password, please try again.",
  GmailNotConnected: "Your Google email isn’t connected to a Fullscript account.",
  PleaseTryAnotherEmail: "Please try another email, or <1>sign up</1>.",
  signUpRedirectCTA: "sign up",
} as const;
